import React from 'react'

export default function Footer() {
  return (
    <footer className="w-full  flex flex-col bg-white text-center py-4 bg-gray-100 text-gray-500 text-sm flex items-center justify-center" >
      <div className='flex text-bold text-[16px] text-[#035DB7]'>
      <span className='ml-3'> ©</span>
      <p>
        کلیه حقوق مادی و معنوی سایت برای سمیتیو محفوظ است.
      </p>
      </div>
    
      <p className='text-[#035DB7]'>
        نسخه ۳.۶.۰
      </p>
    </footer>

  )
}
